
// Available hashing algorithms
const HASH_ALGOS = {
  RSA_MD4: 'RSA-MD4',
  RSA_MD5: 'RSA-MD5',
  RSA_MDC2: 'RSA-MDC2',
  RSA_RIPEMD168: 'RSA-RIPEMD160',
  RSA_SHA1: 'RSA-SHA1',
  RSA_SHA1_2: 'RSA-SHA1-2',
  RSA_SHA224: 'RSA-SHA224',
  RSA_SHA256: 'RSA-SHA256',
  RSA_SHA3_224:  'RSA-SHA3-224',
  RSA_SHA3_256: 'RSA-SHA3-256',
  RSA_SHA3_384: 'RSA-SHA3-384',
  RSA_SHA3_512: 'RSA-SHA3-512',
  RSA_SHA384: 'RSA-SHA384',
  RSA_SHA512: 'RSA-SHA512',
  RSA_SHA512_224: 'RSA-SHA512/224',
  RSA_SHA512_256: 'RSA-SHA512/256',
  RSA_SM3: 'RSA-SM3',
  blake2b512: 'blake2b512',
  blake2s256: 'blake2s256',
  rsassa_pkcs1_v1_5_sha3_224: 'id-rsassa-pkcs1-v1_5-with-sha3-224',
  rsassa_pkcs1_v1_5_sha3_256: 'id-rsassa-pkcs1-v1_5-with-sha3-256',
  rsassa_pkcs1_v1_5_sha3_384: 'id-rsassa-pkcs1-v1_5-with-sha3-384',
  rsassa_pkcs1_v1_5_sha3_512: 'id-rsassa-pkcs1-v1_5-with-sha3-512',
  md4: 'md4',
  md4WithRSAEncryption: 'md4WithRSAEncryption',
  md5: 'md5',
  md5_sha1: 'md5-sha1',
  md5WithRSAEncryption: 'md5WithRSAEncryption',
  mdc2: 'mdc2',
  mdc2WithRSA: 'mdc2WithRSA',
  ripemd: 'ripemd',
  ripemd160: 'ripemd160',
  ripemd160WithRSA: 'ripemd160WithRSA',
  rmd160: 'rmd160',
  sha1: 'sha1',
  sha1WithRSAEncryption: 'sha1WithRSAEncryption',
  sha224: 'sha224',
  sha224WithRSAEncryption: 'sha224WithRSAEncryption',
  sha256: 'sha256',
  sha256WithRSAEncryption: 'sha256WithRSAEncryption',
  sha3_224: 'sha3-224',
  sha3_256: 'sha3-256',
  sha3_384: 'sha3-384',
  sha3_512: 'sha3-512',
  sha384: 'sha384',
  sha384WithRSAEncryption: 'sha384WithRSAEncryption',
  sha512: 'sha512',
  sha512_224: 'sha512-224',
  sha512_224WithRSAEncryption: 'sha512-224WithRSAEncryption',
  sha512_256: 'sha512-256',
  sha512_256WithRSAEncryption: 'sha512-256WithRSAEncryption',
  sha512WithRSAEncryption: 'sha512WithRSAEncryption',
  shake128: 'shake128',
  shake256: 'shake256',
  sm3: 'sm3',
  sm3WithRSAEncryption: 'sm3WithRSAEncryption',
  ssl3_md5: 'ssl3-md5',
  ssl3_sha1: 'ssl3-sha1',
  whirlpool: 'whirlpool'
}

const ENCODING = {
  base64: 'base64',
  base64url: 'base64url',
  hex: 'hex',
  binary: 'binary'
}

module.exports = {
  HASH_ALGOS,
  ENCODING,
}
